"use client";

import MenuTitle from "@/components/menu-title";
import { usePathname } from "@/i18n/routing";
import clsx from "clsx";

export default function MenuLayout({ children }: { children: React.ReactNode })
{
  const path = usePathname();
  return (
    <>
      <MenuTitle />
      <section className={clsx("mx-auto min-h-[calc(100svh-60px)] w-full max-w-[475px] pt-4 pb-[calc(80px+1rem)]", {
        "!pt-0": path === "/referral"
      })}>
        {children}
      </section>
    </>
  );
}
